import React, { useRef, useEffect } from 'react';
import {useLocation, Switch, Route, Redirect} from 'react-router-dom';
import AppRoute from './utils/AppRoute';
import ScrollReveal from './utils/ScrollReveal';
import ReactGA from 'react-ga';
import './App.css';

// Layouts
import LayoutDefault from './layouts/LayoutDefault';

// Views 
import Home from './views/Home';
import Blog from "./views/Blog";
import AccessibleFrontends from './views/AccessibleFrontends'
import BlogLayout from "./layouts/BlogLayout";

// Initialize Google Analytics
ReactGA.initialize(process.env.REACT_APP_GA_CODE);

const trackPage = page => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

const App = () => {

  const childRef = useRef();
  let location = useLocation();

  useEffect(() => {
    const page = location.pathname;
    document.body.classList.add('is-loaded')
    childRef.current.init();
    trackPage(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <ScrollReveal
      ref={childRef}
      children={() => (
        <Switch>
          <AppRoute exact path="/" component={Home} layout={LayoutDefault} />
          <AppRoute exact path="/blog" component={Blog} layout={BlogLayout} />
          <AppRoute exact path="/accessible-frontends" component={AccessibleFrontends} layout={LayoutDefault} />
            <Route exact path="/devtools">
                <Redirect to="/digitalks/digitalks.html" />
            </Route>
              <Route exact path="/software-factory">
                <Redirect to="/digitalks/software-factory.html" />
            </Route>
        </Switch>
      )} />
  );
}

export default App;
